import React, { Component } from "react";
import "./Main.css";

// images

import quote from "../images/quote.svg";
import jorge from "../images/jorge.jpg";

// Components
import Hero from "../Hero/Hero";
import Meet from "../Meet/Meet";
import Menu from "../Menu/Menu";
import Cta from "../Cta/Cta";
import Testimonials from "../Testimonials/Testimonials";
import Testimonial from "../Testimonial/Testimonial";
import HomeSocial from "../HomeSocial/HomeSocial";
import HowItWorks from "../HowItWorks/HowItWorks";

class Main extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Hero />
        <Meet />
        <HowItWorks />
        <Menu />
        <Testimonials
          heading="Testimonials"
          icon={quote}
          body="Hear what our satisfied customers have to say."
          content={
            <Testimonial
              name="Jorge Viera"
              img={jorge}
              text="Excellent fresh food and service."
            />
          }
        />
        <HomeSocial />
        <Cta />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main/Main.js